import {
  NJIconButton,
  NJSidepanel,
  NJText,
} from "@engie-group/fluid-design-system-react";
import type { ChatSource } from "./types";

/** Right-hand side panel listing an answer's sources (mirrors the legacy `SourcePanel`). */
export function SourcesPanel({
  title,
  sources,
  onClose,
}: {
  title: string;
  sources: ChatSource[];
  onClose: () => void;
}) {
  return (
    <>
      <div
        className="fixed inset-0 z-40 bg-black/30"
        role="presentation"
        onClick={onClose}
      />
      <div className="fixed inset-y-0 right-0 z-50 w-[400px] max-w-full border-l border-nj-neutral-subtle-default bg-nj-neutral-primary-default shadow-lg">
        <NJSidepanel
          header={
            <div className="flex items-center justify-between gap-2 border-b border-nj-neutral-subtle-default px-4 py-3">
              <NJText as="span" scale="md" className="font-nj-bold">
                {title}
              </NJText>
              <NJIconButton
                icon="close"
                label="Close"
                size="sm"
                onClick={onClose}
              />
            </div>
          }
        >
          <div className="flex flex-col gap-3 p-4">
            {sources.map((source, index) => (
              <div
                key={index}
                className="flex flex-col gap-1 rounded-lg border border-nj-neutral-subtle-default p-3"
              >
                {source.title && (
                  <NJText as="span" scale="sm" className="font-nj-bold">
                    {source.title}
                  </NJText>
                )}
                {source.text && (
                  <NJText
                    as="p"
                    scale="sm"
                    className="text-nj-neutral-secondary-default"
                  >
                    {source.text}
                  </NJText>
                )}
                {source.url && (
                  <a
                    href={source.url}
                    target="_blank"
                    rel="noreferrer"
                    className="truncate text-sm text-nj-brand-solid-default hover:underline"
                  >
                    {source.url}
                  </a>
                )}
              </div>
            ))}
          </div>
        </NJSidepanel>
      </div>
    </>
  );
}
